import {
  SAVE_DEAL_PARTICIPANT_LIST, SAVE_DEAL_PARTICIPANT_LIST_SUCCESS, SAVE_DEAL_PARTICIPANT_LIST_ERROR,
  SAVE_DEAL_PARTICIPANT_COMMENT, DELETE_DEAL_PARTICIPANT_COMMENT_SUCCESS, SAVE_DEAL_PARTICIPANT_COMMENT_SUCCESS,
  LOGIN_USER_SUCCESS, LOGOUT_USER_SUCCESS,
} from '../../../constants/system/actions';

const dealParticipantsReducer: Reducer = (
  state: ReducerState = {
    commentList: null,
    isFormSaving: false,
    isCommentSaving: false,
  },
  action: ReduxAction,
): ReducerState => {
  switch (action.type) {
    case SAVE_DEAL_PARTICIPANT_LIST:
      return {
        ...state,
        isFormSaving: true,
      };
    case SAVE_DEAL_PARTICIPANT_LIST_SUCCESS:
    case SAVE_DEAL_PARTICIPANT_LIST_ERROR:
      return {
        ...state,
        isFormSaving: false,
      };
    case SAVE_DEAL_PARTICIPANT_COMMENT:
      return {
        ...state,
        isCommentSaving: true,
      };
    case DELETE_DEAL_PARTICIPANT_COMMENT_SUCCESS:
    case SAVE_DEAL_PARTICIPANT_COMMENT_SUCCESS:
      return {
        ...state,
        isCommentSaving: false,
        commentList: action.data.comments,
      };
    case LOGIN_USER_SUCCESS:
    case LOGOUT_USER_SUCCESS:
      return {
        ...state,
        commentList: null,
        isFormSaving: false,
        isCommentSaving: false,
      };
    default:
      return state;
  }
};

export default dealParticipantsReducer;
